import { Redirect, Route } from 'react-router-dom';
import { isBoolean } from 'lodash';
import T from 'prop-types';
import { ability } from '@oliasoft/authorization-ui';
import { NAVIGATION_CONSTANTS } from '../constants';

export const PrivateRoute = ({ component: Component, canNavigate, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        //canNavigate can be CASL object or boolean for routes that dont require any permissions to enter
        let hasPermissionToNavigate;
        if (isBoolean(canNavigate) && !!canNavigate) {
          hasPermissionToNavigate = true;
        } else {
          hasPermissionToNavigate = ability.can(canNavigate?.action, canNavigate?.subject);
        }
        return hasPermissionToNavigate
          ? <Component {...props} {...rest}/>
          : <Redirect to={NAVIGATION_CONSTANTS.SETTINGS_ROUTE} />;
      }}
    />
  );
};

PrivateRoute.propTypes = {
  component: T.elementType.isRequired,
  canNavigate: T.any,
};
